import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api/api";
import { AuthContext } from "../shared/Contexts/Auth/AuthContext";

const RedirectPage = () => {
  const location = useLocation();
  const useQuery = () => {
    return new URLSearchParams(location.search);
  };

  const { isLoggedIn } = useContext(AuthContext);

  const query = useQuery();
  const navigate = useNavigate();
  const fileUrl = query.get("fileUrl");

  useEffect(() => {
    const handleRedirect = async (fileUrl: string) => {
      if (!isLoggedIn) {
        navigate(`/login?fileUrl=${fileUrl}`);
        return;
      }
      const link = await api.getTemporaryLinkToFile({
        fileUrl: fileUrl,
      });
      window.location.href = link.signedUrl;
    };
    if (fileUrl) {
      try {
        handleRedirect(fileUrl);
      } catch (error) {
        console.log("Error while redirecting user: ", error);
      }
    }
  }, [fileUrl, isLoggedIn, navigate]);
  return null;
};

export default RedirectPage;
